// extracted by mini-css-extract-plugin
export default {"infoItem":"GpsPetitionMetadata_infoItem__9Kr9t","icon":"GpsPetitionMetadata_icon__cXTc6"};